export const environment = {
    production: false,
    config: {
        appName: 'Direcția de Impozite și Taxe',
        appDescription: 'DGITL Operator',
        fromTokenValid:
            'https://development.auth-core.webproductionlabs.com/api/login',
        tokenKey: 'wpl-staging-operator-app-token', // this token is used for every request where is needed
        userKey: 'wpl-staging-operator-app-user', // here we find local storage with minimal user data
        storageKey: 'wpl-staging-operator', // here we find key for predefined local storage for app functionalities
        copyrightText: 'Copyright © Direcția Generală de Impozite și Taxe Sector 4 - 2024',
        defaultLNG: 'ro',
        emailRegex:
            '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$',
        codeSMSRegex: /^[0-9]+$/,
        phoneRegex: '[0-9]{6,20}',
        cnpRegex: '[0-9]{13,13}',
        validatorsAccrossApp: {
            minPassword: 8,
            maxPassword: 30,
            emailMaxLength: 50,
            minStringLength: 2,
            maxStringLength: 60,
            minSmsCodeLength: 1,
            maxSmsCodeLength: 1,
        },
        customNotifications: {
            icons: {
                success: 'success',
                error: 'error',
                info: 'info',
                warning: 'warning',
            },
            headers: {
                success: 'Success',
                error: 'Eroare',
                successForm: 'Felicitari!',
            },
            generalMessages: {
                error: 'Ne pare rău, dar am întâmpinat o problemă. Vă rugam să reîncercați. Dacă problema persistă, vă rugăm să ne contactați prin butonul de suport IT.',
            },
        },
        romanianLanguageDataTable: {
            sEmptyTable: 'Niciun rezultat găsit',
            sInfo: 'Afișate de la _START_ până la _END_ din _TOTAL_ înregistrări',
            sInfoEmpty: 'Afișate de la 0 până la 0 din 0 înregistrări',
            sInfoFiltered: '(filtrat din _TOTAL_ înregistrări)',
            sInfoPostFix: '',
            sInfoThousands: ',',
            sLengthMenu: 'Afișează _MENU_ înregistrări pe pagină',
            sLoadingRecords: 'Încărcare...',
            sProcessing: 'Procesare...',
            sSearch: 'Caută:',
            sZeroRecords: 'Niciun rezultat găsit',
            oPaginate: {
                sFirst: 'Prima',
                sLast: 'Ultima',
                sNext: 'Următoarea',
                sPrevious: 'Anterioara',
            },
            oAria: {
                sSortAscending: ': activează pentru a sorta coloana crescător',
                sSortDescending: ': activează pentru a sorta coloana descrescător',
            },
        },
    },
    interop: {
        basePath: 'https://development.dgitl-core.webproductionlabs.com/',
        // basePath: 'https://wpl-dgitl-core/',
        clientId: 3,
        moduleId: 4,
        dgitl: {
            authorizeShortToken: 'authorization_code/',
            notifications: {
                authNotifications: 'api/dgitl/auth-notifications',
            },
            settings: {
                configurations: {
                    getConfigurations: 'api/settings/configuration/list',
                    getConfigurationsDT: 'api/settings/configuration/list-dt',
                    getSlugConfiguration: 'api/settings/configuration/find/', // + slug
                    getConfiguration: 'api/settings/configuration/one/', // + id
                    putConfiguration: 'api/settings/configuration/update', // id in payload
                    storeConfiguration: 'api/settings/configuration/store',
                    deleteConfiguration: 'api/settings/configuration/delete/',
                },
                imageType: {
                    // used to resize images to certain sizes
                    getImageTypesDT: 'api/settings/image-type/list-dt',
                    postImageType: 'api/settings/image-type/store',
                    getImageTypes: 'api/settings/image-type/list',
                    getImageType: 'api/settings/image-type/find/', // + id
                    putImageType: 'api/settings/image-type/update', // id in payload
                    deleteImageType: 'api/settings/image-type/delete/', // + id
                },
            },
            cerere: {
                getCereriDT: 'api/dgitl/cereri',
                findCerere: 'api/dgitl/cerere/', // + id
                storeCereri: 'api/dgitl/cerere',
                updateAssignee: 'api/dgitl/update-asignee/', // + id
                updateStatus: 'api/dgitl/update-status/', // + id
                updatePriority: 'api/dgitl/update-priority/', // + id

                postMessage: 'api/dgitl/post-message/', // + id
                getMessages: 'api/dgitl/history/', // + id

                downloadDocument: 'api/dgitl/file-download/', // + id

                preluarePersoanala: 'api/dgitl/preluare-cerere/', // + id
                preluareNumarRegistratura: 'api/dgitl/generate-reg-number/', // + id
                validateCerere: 'api/dgitl/validate/', // + id
                invalidateCerere: 'api/dgitl/invalidate/', // + id
                anulareCerere: 'api/dgitl/anulare/', // + id
                finalizareCerere: 'api/dgitl/finalize-cerere/', // + id

                massAssign: 'api/dgitl/update-mass-asignee',
                massUpdateStatus: 'api/dgitl/update-mass-status',
                massUpdatePriority: 'api/dgitl/update-mass-priority',
                massInchidereLucrare: 'api/dgitl/update-mass-close',

                getTipuriByDepartament: 'api/dgitltypes/compartiment/',

                file: {
                    fileUpload: 'api/dgitl/upload-file',
                    fileUploadBase64: 'api/dgitl/upload-file-base64',
                },

                getCompartimente: 'api/directie-compartiment/get-module-compartimente',
                getCompartimenteByAccess: 'api/directie-compartiment/get-module-compartimente-access',
                getActiveUsersByCompartiment: 'api/user/list-users-compartiment',

                getSources: 'api/settings/source-list',

                exportHistory: 'api/dgitl/export-message-pdf/', // + id_cerere + user type (1 => operator, 2 => cetatean, 3 => tot)
                exportDocumentUat: 'api/dgitl/export-document-uat-pdf',

                resetValidareCerere: 'api/dgitl/cerere/reset/validare/', // id_cerere - PUT
                resetinValidareCerere: 'api/dgitl/cerere/reset/invalidare/', // id_cerere - PUT
                resetClasareCerere: 'api/dgitl/cerere/reset/clasare/', // id_cerere - PUT
                resetInchidereCerere: 'api/dgitl/cerere/reset/finalizare/', // id_cerere - POST

                sendEmail: 'api/dgitl/send-uat-message',
                resetEmail: 'api/dgitl/retrimite-notificare',

                rePostMessage: 'api/dgitl/re-post-message/', // + id

                getMatricole: 'api/dgitl/cerere/get-matricole/', // + id
                downloadCF: 'api/dgitl/cf/file-download/', // + id
                cancelCF: 'api/dgitl/cf/anulare/', // + id
                generateCF: 'api/dgitl/cerere/generate-cf/', // + id

                updateEmailCetatean: 'api/dgitl/update-cet-email/', // + id
            },
            confirmareDocumente: {
                getDocumenteCofirmareDT: 'api/dgitl/get-documente-confirmate',
                fileDownload: 'api/dgitl/file-download/', // + id
            },
            nomenclatoare: {
                cererePriority: {
                    getCererePrioritiesDT: 'api/dgitlpriorities',
                    getCererePriorities: 'api/dgitlpriorities',
                    putCererePriority: 'api/dgitl/priority',
                    deleteCererePriority: 'api/dgitl/priority/', // + id
                    storeCererePriority: 'api/dgitl/priority',
                    clearCache: 'api/dgitl/priority-cache/clear',
                    changeStatusCererePriorityActive: 'api/dgitl/priority-active/', // + id
                    changeStatusCererePriorityPublic: 'api/dgitl/priority-public/', // + id
                },
                cerereStatus: {
                    getCerereStatusesDT: 'api/dgitlstatuses',
                    getCerereStatuses: 'api/dgitlstatuses',
                    putCerereStatus: 'api/dgitl/status', // id in payload
                    deleteCerereStatus: 'api/dgitl/status/', // + id
                    storeCerereStatus: 'api/dgitl/status',
                    changeStatusCerereStatusActive: 'api/dgitl/status/active/', // + id
                    changeStatusCerereStatusPublic: 'api/dgitl/status/public/', // + id
                    updateOrder: 'api/dgitl/status/update-order/', // + id => put request
                    rankList: 'api/dgitl/status-rank/rank-list',
                    clearCache: 'api/dgitl/status-cache/clear',
                },
                cerereType: {
                    getCerereTypesDT: 'api/dgitltypes',
                    getCerereTypes: 'api/dgitltypes',
                    putCerereType: 'api/dgitl/type', // id in payload
                    deleteCerereType: 'api/dgitl/type/', // + id
                    storeCerereType: 'api/dgitl/type',
                    clearCache: 'api/dgitl/type-cache/clear',
                    changeStatusCerereTypeActive: 'api/dgitl/cerere-type/active/', // + id
                    changeStatusCerereTypePublic: 'api/dgitl/cerere-type/public/', // + id
                },
                cerereSabloane: {
                    getCerereSabloaneDT: 'api/dgitl-sabloane-dt',
                    getCerereSabloane: 'api/dgitl-sabloane',
                    putCerereSablon: 'api/dgitl-sabloane', // id in payload
                    deleteCerereSablon: 'api/dgitl-sabloane/', // + id
                    storeCerereSablon: 'api/dgitl-sabloane',
                },
                uat: {
                    getUatDT: 'api/dgitluats',
                    putUat: 'api/dgitl/uat', // id in payload
                    deleteUat: 'api/dgitl/uat/', // + id
                    storeUat: 'api/dgitl/uat',
                },
                directie: {
                    getDirectii: 'api/directie/list',
                    getDirectiiActive: 'api/directie/list/active',
                },
                compartimente: {
                    getCompartimente: 'api/directie-compartiment/list',
                    getCompartimenteActive: 'api/directie-compartiment/list/active',
                    getCompartimenteByDirectie: 'api/directie-compartiment/listByDirectie/',
                },
                user: {
                    getUsersList: 'api/user/list-all-users',
                    getActiveUsersByOrganigrama: 'api/user/list-users-organigrama',
                },
                operatori: {
                    getOperatoriDT: 'api/user/list-module-users',
                    getOperatorCerereById:
                        'api/nomenclatoare/user/list-cerere-types-user/', // + id
                    updateOperator: 'api/settings/operatori/update-cereri-permissions',
                    getOperatorPermisiuniList:
                        'api/settings/operatori/operator-cereri-permissions-list',
                    getOperatorFunctie: 'api/settings/operatori/operator-cereri-functie/', // user_id
                    updateOperatorFunctie: 'api/settings/operatori/operator-cereri-functie-update/', // user_id, payload {functie_id}
                },
                functiiUser: {
                    list: 'api/nomenclatoare/functie/list',
                    listActive: 'api/nomenclatoare/functie/list/active',
                },
                crons: {
                    list: 'api/nomenclatoare/cron/list',
                    listDT: 'api/nomenclatoare/cron/list-dt',
                    listActive: 'api/nomenclatoare/cron/list-active',
                    store: 'api/nomenclatoare/cron/store',
                    update: 'api/nomenclatoare/cron/update',
                    updateStatus: 'api/nomenclatoare/cron/change-status/',
                    delete: 'api/nomenclatoare/cron/delete/',
                },
                directieCompartimente: {
                    listByDirectie: 'api/directie-compartiment/listByDirectie/', // + id
                    listDT: 'api/directie-compartiment/index-dt',
                    changeStatusDirectieCompartimenteActive: 'api/directie-compartiment/active/', // + id
                    changeStatusDirectieCompartimentePublic: 'api/directie-compartiment/public/', // + id
                },
            },
        },
        urbanism: {
            settings: {
                configurations: {
                    // PLATFORM CONFIGURATION - URBANISM
                    getConfigurations: 'api/settings/configuration/list',
                    getConfigurationsDT: 'api/settings/configuration/list-dt',
                    getSlugConfiguration: 'api/settings/configuration/find/', // + slug
                    getConfiguration: 'api/settings/configuration/one/', // + id
                    putConfiguration: 'api/settings/configuration/update', // id in payload
                    storeConfiguration: 'api/settings/configuration/store',
                },
            },
            nomenclatoare: {
                permissions: {
                    getUserPermissions: 'api/nomenclatoare/permission/list',
                    getUserPermissionsActive: 'api/nomenclatoare/permission/list/active',
                    getUserPermissionsActivePublic:
                        'api/nomenclatoare/permission/list/public',
                    getUserPermission: 'api/nomenclatoare/permission/find/', // + id
                    changeStatusUserPermissionActive:
                        'api/nomenclatoare/permission/active/', // + id
                    changeStatusUserPermissionPublic:
                        'api/nomenclatoare/permission/public/', // + id
                    deleteUserPermission: 'api/nomenclatoare/permission/delete/', // + id
                    storeUserPermission: 'api/nomenclatoare/permission/store',
                },
                permissionActions: {
                    getPermissionActionsDT: 'api/nomenclatoare/permission-action/list-dt',
                    getPermissionActions: 'api/nomenclatoare/permission-action/list',
                    getPermissionActionsActive:
                        'api/nomenclatoare/permission-action/list/active',
                    getPermissionActionsActivePublic:
                        'api/nomenclatoare/permission-action/list/public',
                    getPermissionAction: 'api/nomenclatoare/permission-action/find/', // + id
                    putPermissionAction: 'api/nomenclatoare/permission-action/update',
                    changeStatusPermissionActionActive:
                        'api/nomenclatoare/permission-action/active/', // + id
                    changeStatusPermissionActionPublic:
                        'api/nomenclatoare/permission-action/public/', // + id
                    deletePermissionAction: 'api/nomenclatoare/permission-action/delete/', // + id
                    storePermissionAction: 'api/nomenclatoare/permission-action/store',
                },
                section: {
                    // sections from within the platform
                    getSectionsDT: 'api/nomenclatoare/section/list-dt',
                    getSections: 'api/nomenclatoare/section/list',
                    getSectionsActive: 'api/nomenclatoare/section/list/active',
                    getSectionsActivePublic: 'api/nomenclatoare/section/list/public',
                    getSection: 'api/nomenclatoare/section/find/', // + id
                    putSection: 'api/nomenclatoare/section/update', // id in payload
                    changeStatusSectionActive: 'api/nomenclatoare/section/active/', // + id
                    changeStatusSectionPublic: 'api/nomenclatoare/section/public/', // + id
                    deleteSection: 'api/nomenclatoare/section/delete/', // + id
                    storeSection: 'api/nomenclatoare/section/store',
                },
                functie: {
                    // functii operatori from the platform
                    getFunctiiDT: 'api/nomenclatoare/functie/list-dt',
                    getFunctii: 'api/nomenclatoare/functie/list',
                    getFunctiiActive: 'api/nomenclatoare/functie/list/active',
                    getFunctiiActivePublic: 'api/nomenclatoare/functie/list/public',
                    getFunctie: 'api/nomenclatoare/functie/find/', // + id
                    putFunctie: 'api/nomenclatoare/functie/update', // id in payload
                    changeStatusFunctieActive: 'api/nomenclatoare/functie/active/', // + id
                    changeStatusFunctiePublic: 'api/nomenclatoare/functie/public/', // + id
                    deleteFunctie: 'api/nomenclatoare/functie/delete/', // + id
                    storeFunctie: 'api/nomenclatoare/functie/store',
                },
                imageType: {
                    // used to resize images to certain sizes
                    getImageTypesDT: 'api/nomenclatoare/image-type/list-dt',
                    postImageType: 'api/nomenclatoare/image-type/store',
                    getImageTypes: 'api/nomenclatoare/image-type/list',
                    getImageType: 'api/nomenclatoare/image-type/find/', // + id
                    putImageType: 'api/nomenclatoare/image-type/update', // id in payload
                    deleteImageType: 'api/nomenclatoare/image-type/delete/', // + id
                },
                cerereType: {
                    getCerereTypes: 'api/nomenclatoare/cerere-type/list',
                    getCerereType: 'api/nomenclatoare/cerere-type/find/', // + id
                    putCerereType: 'api/nomenclatoare/cerere-type/update', // id in payload
                    deleteCerereType: 'api/nomenclatoare/cerere-type/delete/', // + id
                    storeCerereType: 'api/nomenclatoare/cerere-type/store',
                    getCerereTypesActive: 'api/nomenclatoare/cerere-type/list/active',
                    getCerereTypesActivePublic:
                        'api/nomenclatoare/cerere-type/list/public',
                    changeStatusCerereTypeActive: 'api/nomenclatoare/cerere-type/active/', // + id
                    changeStatusCerereTypePublic: 'api/nomenclatoare/cerere-type/public/', // + id
                },
                cerereStatus: {
                    getCerereStatuses: 'api/nomenclatoare/cerere-status/list',
                    getCerereStatus: 'api/nomenclatoare/cerere-status/find/', // + id
                    putCerereStatus: 'api/nomenclatoare/cerere-status/update', // id in payload
                    deleteCerereStatus: 'api/nomenclatoare/cerere-status/delete/', // + id
                    storeCerereStatus: 'api/nomenclatoare/cerere-status/store',
                    getCerereStatusesActive:
                        'api/nomenclatoare/cerere-status/list/active',
                    getCerereStatusesActivePublic:
                        'api/nomenclatoare/cerere-status/list/public',
                    changeStatusCerereStatusActive:
                        'api/nomenclatoare/cerere-status/active/', // + id
                    changeStatusCerereStatusPublic:
                        'api/nomenclatoare/cerere-status/public/', // + id
                },
                cererePriority: {
                    // getCererePrioritiesDT: 'api/nomenclatoare/cerere-priority/list-dt',
                    getCererePriorities: 'api/nomenclatoare/cerere-priority/list',
                    getCererePriority: 'api/nomenclatoare/cerere-priority/find/', // + id
                    putCererePriority: 'api/nomenclatoare/cerere-priority/update', // id in payload
                    deleteCererePriority: 'api/nomenclatoare/cerere-priority/delete/', // + id
                    storeCererePriority: 'api/nomenclatoare/cerere-priority/store',
                    getCererePrioritiesActive:
                        'api/nomenclatoare/cerere-priority/list/active',
                    getCererePrioritiesActivePublic:
                        'api/nomenclatoare/cerere-priority/list/public',
                    changeStatusCererePriorityActive:
                        'api/nomenclatoare/cerere-priority/active/', // + id
                    changeStatusCererePriorityPublic:
                        'api/nomenclatoare/cerere-priority/public/', // + id
                },
                cerereSabloane: {
                    getCerereSabloaneDT: 'api/nomenclatoare/cerere-sabloane/list-dt',
                    getCerereSabloane: 'api/nomenclatoare/cerere-sabloane/list',
                    getCerereSablon: 'api/nomenclatoare/cerere-sabloane/find/', // + id
                    putCerereSablon: 'api/nomenclatoare/cerere-sabloane/update', // id in payload
                    deleteCerereSablon: 'api/nomenclatoare/cerere-sabloane/delete/', // + id
                    storeCerereSablon: 'api/nomenclatoare/cerere-sabloane/store',
                    getCerereSabloaneActive:
                        'api/nomenclatoare/cerere-sabloane/list/active',
                    getCerereSabloaneActivePublic:
                        'api/nomenclatoare/cerere-sabloane/list/public',
                    changeStatusCerereSablonActive:
                        'api/nomenclatoare/cerere-sabloane/active/', // + id
                    changeStatusCerereSablonPublic:
                        'api/nomenclatoare/cerere-sabloane/public/', // + id
                },
                platformSection: {
                    // sections to be displayed and grouped for cetateni. !!! ALSO. From this section, we can get all the next resources to show to operator. Content, FAQ, Announces
                    getPlatformSectionsDT: 'api/nomenclatoare/platform-section/list-dt',
                    getPlatformSections: 'api/nomenclatoare/platform-section/list',
                    getPlatformSection: 'api/nomenclatoare/platform-section/find/', // + id
                    putPlatformSection: 'api/nomenclatoare/platform-section/update', // id in payload
                    deletePlatformSection: 'api/nomenclatoare/platform-section/delete/', // + id
                    storePlatformSection: 'api/nomenclatoare/platform-section/store',
                    getPlatformSectionsActive:
                        'api/nomenclatoare/platform-section/list/active',
                    changeStatusPlatformSectionActive:
                        'api/nomenclatoare/platform-section/active/', // + id
                },
                platformFAQ: {
                    // frequently asked questions, for platform cetateni
                    getPlatformFAQs: 'api/nomenclatoare/platform-faq/list', // ?section_id={id}
                    getPlatformFAQ: 'api/nomenclatoare/platform-faq/find/', // + id
                    putPlatformFAQ: 'api/nomenclatoare/platform-faq/update', // id in payload
                    deletePlatformFAQ: 'api/nomenclatoare/platform-faq/delete/', // + id
                    storePlatformFAQ: 'api/nomenclatoare/platform-faq/store',
                    getPlatformFAQsActive: 'api/nomenclatoare/platform-faq/list/active', // ?section_id={id}
                    changeStatusPlatformFAQActive:
                        'api/nomenclatoare/platform-faq/active/', // + id
                },
                platformContent: {
                    // content for platform cetateni
                    getPlatformContentsDT: 'api/nomenclatoare/platform-content/list-dt',
                    getPlatformContents: 'api/nomenclatoare/platform-content/list', // ?section_id={id}
                    getPlatformContent: 'api/nomenclatoare/platform-content/find/', // + id
                    putPlatformContent: 'api/nomenclatoare/platform-content/update', // id in payload
                    deletePlatformContent: 'api/nomenclatoare/platform-content/delete/', // + id
                    storePlatformContent: 'api/nomenclatoare/platform-content/store',
                    getPlatformContentsActive:
                        'api/nomenclatoare/platform-content/list/active', // ?section_id={id}
                    changeStatusPlatformContentActive:
                        'api/nomenclatoare/platform-content/active/', // + id
                },
                platformAnnounces: {
                    // announces for platform cetateni
                    getPlatformAnnouncesDT:
                        'api/nomenclatoare/platform-announces/list-dt',
                    getPlatformAnnounces: 'api/nomenclatoare/platform-announces/list', // ?section_id={id}
                    getPlatformAnnounce: 'api/nomenclatoare/platform-announces/find/', // + id
                    putPlatformAnnounce: 'api/nomenclatoare/platform-announces/update', // id in payload
                    deletePlatformAnnounce:
                        'api/nomenclatoare/platform-announces/delete/', // + id
                    storePlatformAnnounce: 'api/nomenclatoare/platform-announces/store',
                    getPlatformAnnouncesActive:
                        'api/nomenclatoare/platform-announce/list/active', // ?section_id={id}
                    changeStatusPlatformAnnounceActive:
                        'api/nomenclatoare/platform-announce/active/', // + id
                },
                judet: {
                    getJudete: 'api/nomenclatoare/judet/list',
                    getJudeteDT: 'api/nomenclatoare/judet/list-dt',
                    getJudet: 'api/nomenclatoare/judet/find/', // + id
                    putJudet: 'api/nomenclatoare/judet/update', // id in payload
                    deleteJudet: 'api/nomenclatoare/judet/delete/', // + id
                    storeJudet: 'api/nomenclatoare/judet/store',
                    getJudeteActive: 'api/nomenclatoare/judet/list/active',
                    getJudeteActivePublic: 'api/nomenclatoare/judet/list/public',
                    changeStatusJudetActive: 'api/nomenclatoare/judet/active/', // + id
                    changeStatusJudetPublic: 'api/nomenclatoare/judet/public/', // + id
                },
            },
        },
        authCore: {
            basePath: 'https://development.auth-core.webproductionlabs.com/',
            linkRedirectAuth: 'https://development.app.webproductionlabs.com/#/aplicatii',
            platform: {
                getUserDetails: 'api/user/1/1', // get user from token and also validate token for operator to autorize actions
                getUserPermissionsAuthLib:
                    'api/client/module/permission/user/getUserPermissionsAuthLib/',
            },
        },
    },
};

/*
 *  To run this proper configuration, please use: ng serve
 */
